module.exports = __webpack_public_path__ + "img/Multi-Tier-System.d840f48.png";